import { Component, Input, Pipe, PipeTransform, EventEmitter, Output, OnDestroy, ViewChild, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

import {SlideshowService} from '../../slideshow.service';
import {ImagesService} from '../../../shared/images.service';
import {GettyService} from '../../../getty/getty.service';
import {MediaDialog} from '../../images/media-dialog';
import { Utils } from '../.././../utils';

@Pipe({name: 'tempImages'})
export class TempImagesPipe implements PipeTransform {
    transform(list, groupIds): string {
        if( !list || !groupIds ) {
            return list;
        }
        return list.filter(item => {
            return groupIds.indexOf(item.groupId) !== -1;
        });
    }
}
@Component({
    selector: 'image-component',
    templateUrl: 'image.component.html'
})
export class ImageComponent implements OnDestroy {
    imageUploadSubscription;
    gettyDownloadSubscription;
    loading = false;

    private _canEdit = false;
    private _images = [];
    private _imagesMobile = [];
    private _single = false;
    private _adsTab = false;
    private _placeholderOnly = false;
    
    @Input('canEdit')
    set canEdit(canEdit) {
        this._canEdit = canEdit;
    }
    get canEdit() {
        return this._canEdit;
    }
    @Input('images')
    set images(images) {
        this._images = images;
    }
    get images() {
        return this._images;
    }
    @Input('imagesMobile')
    set imagesMobile(imagesMobile) {
        this._imagesMobile = imagesMobile;
    }
    get imagesMobile() {
        return this._imagesMobile;
    }
    @Input('single')
    set single(single) {
        this._single = single;
    }
    get single() {
        return this._single;
    }
    private _singleImage;
    @Input('singleImage')
    set singleImage(image) {
        this._singleImage = image;
        if( image ) {
            this.images = [this.singleImage];
        } else {
            this.images = [];
        }
    }
    get singleImage() {
        return this._singleImage;
    }
    @Input('adsTab')
    set adsTab(adsTab) {
        this._adsTab = adsTab;
    }
    get adsTab() {
        return this._adsTab;
    }
    @Input('placeholderOnly')
    set placeholderOnly(placeholderOnly) {
        this._placeholderOnly = placeholderOnly;
    }
    get placeholderOnly() {
        return this._placeholderOnly;
    }
    
    private _direct;
    @Input('direct')
    set direct(handle) {
        this._direct = handle;
    }
    get direct() {
        return this._direct;
    }

    @Output() slideImagesChange = new EventEmitter<any>();

    @ViewChild('imageInput') imageInput;
    @ViewChild('imageInputMobile') imageInputMobile;

    constructor(
        private dialog: MatDialog,
        private imagesService: ImagesService, 
        public slideshow: SlideshowService,
        public gettyService: GettyService,
        public utils: Utils
    ) {}
    insertImage(image, mobile) {
        let list = this.images;
        if (!this.placeholderOnly) {
            if( mobile ) {
                list = this.imagesMobile;
            } else {
                const mobileList = this.imagesMobile;
                let i = mobileList.length;
                while(i--) {
                    if( mobileList[i].id == image.id ) {
                        this.imagesMobile.splice(i, 1);
                    }
                }
            }
            if( this.single || mobile ) {
                list[0] = image;
            } else {
                list.push(image);
            }
        }
        const slideImageInfo = {
            mobile: mobile,
            images: this.placeholderOnly ? image : (mobile ? this.imagesMobile : this.images)
        };
        if (this.direct) {
            this.direct(slideImageInfo);
        } else {
            this.slideImagesChange.emit(slideImageInfo);
        }
    }
    maybeInsertImage(image, mobile) {
        if( image.error ) {
            return;
        }
        if( !mobile && this.listHasImage(image.id) ) {
            return;
        }
        if( !image.sizes.ad || image.sizes.ad.width !== 1200 || image.sizes.ad.height !== 628 ) {
            this.imagesService.resetAdSize(image);
        }
        if ( !image.sizes.feed_applenews ) {
            this.imagesService.resetAppleNewsSize(image);
        }
        if( this.mustAddDetails(image) ) {
            this.popImageDialog(image, true, mobile, true);
        } else {
            this.insertImage(image, mobile);
        }
    }
    listHasImage(id) {
        const list = this.images;
        for(var i = 0; i < list.length; i++) {
            const item = list[i];
            if( id == item.id ) {
                return true;
            }
        }
        return false;
    }
    drop(e, mobile) {
        if( !this.canEdit ) {
            return;
        }

        if( !e.isExternal ) {
            const imgIndex = e.data;
            let img = this.imagesService.images[imgIndex];
            if( !mobile && this.listHasImage(img.id) ) {
                return;
            }
            const mobileCheck = img.sizes.full.crop || img.sizes.full;
            if( !mobile && !img.sizes.desktop && mobileCheck.width < 600 ) {
                this.dialog.open(MobileOnlyDialog);
                return;
            }
            if( !this.imagesService.isMobileOnlyImage(img) && !img.sizes.desktop && img.sizes.full.width >= 600 && !img.allowPortrait && !img.allow600 ) {
                this.imagesService.resetDesktopSize(img, true);
            }
            if( this.slideshow.quiz && img.sizes.quiz && (img.sizes.quiz.width !== 756 || img.sizes.quiz.height !== 331) ) {
                this.imagesService.resetQuizSize(img);
            }
            this.maybeInsertImage(img, mobile);
            return;
        }

        this.handleImageUpload(e, mobile);
    }
    handleImageUpload(e, mobile) {
        if( !this.canEdit ) {
            return;
        }
        let count = e.event.dataTransfer.files.length;
        if( count === 0 ) {
            const text = e.data;
            if( text ) {
                try {
                    const img = JSON.parse(text);
                    if( typeof img === 'object' ) {
                        this.gettyDownloadSubscription = this.gettyService.downloadComplete.subscribe(image => {
                            if( !image.error && !mobile && !image.sizes.desktop && image.sizes.full.width < 600 ) {
                                this.dialog.open(MobileOnlyDialog);
                            } else {
                                this.maybeInsertImage(image, mobile); 
                            }
                            this.gettyDownloadSubscription.unsubscribe();
                        });
                        this.gettyService.download(img, this.slideshow.assignment.id);
                    }
                } catch(error) {
                    alert('could not read file');
                    throw error;
                }
            }
            return;
        }

        this.imageUploadSubscription = this.imagesService.imageUploaded.subscribe(img => {
            count -= 1;
            if( !img.error && !mobile && !img.sizes.desktop && img.sizes.full.width < 600 ) {
                this.dialog.open(MobileOnlyDialog);
            } else {
               this.maybeInsertImage(img, mobile); 
            }
            if( count == 0 ) {
                this.imageUploadSubscription.unsubscribe();
            }
        });
        this.imagesService.handleDropFiles(e.event.dataTransfer.files, this.slideshow.assignment, true);
    }
    mustAddDetails(img) {
        return !this.adsTab && (!img.caption || !img.title || !img.alt);
    }
    openFiles(mobile) {
        if( !this.canEdit ) {
            return;
        }
        if( mobile ) {
            this.imageInputMobile.nativeElement.value = '';
            this.imageInputMobile.nativeElement.click();
        } else {
            this.imageInput.nativeElement.value = '';
            this.imageInput.nativeElement.click();
        }
    }
    popImageDialog(image, addToSlide, mobile, mustAddDetails = false) {
        const dialog = this.dialog.open(MediaDialog, {
            panelClass: 'media-dialog',
            data: {
                image: image,
                canEdit: this.canEdit,
                quiz: this.slideshow.quiz,
                showDesktop: !mobile,
                addToSlide: this.slideshow.locked ? false : addToSlide,
                adsTab: this.adsTab,
                mustAddDetails: mustAddDetails
            }
        });
        dialog.afterClosed().subscribe(img => {
            if( this.slideshow.locked || !img ) {
                return;
            }
            if( !mobile && this.listHasImage(img.id) ) {
                this.slideImagesChange.emit({
                    mobile: mobile,
                    images: mobile ? this.imagesMobile : this.images
                });
                return;
            }
            const mobileCheck = img.sizes.full.crop || img.sizes.full;
            if( !mobile && !img.sizes.desktop && mobileCheck.width < 600 ) {
                mobile = true;
            }
            if( img && addToSlide ) {
                this.maybeInsertImage(img, mobile);
            }
        });
    }
    removeAttachment(images, i, mobile) {
        images.splice(i, 1);
        this.slideImagesChange.emit({
            mobile: mobile,
            images: mobile ? this.imagesMobile : this.images
        });
    }
    getDimensions(image, mobile) {
        let useImage = image.sizes.desktop ? image.sizes.desktop : image.sizes.full;
        if( mobile ) {
            useImage = image.sizes.mobile ? image.sizes.mobile : image.sizes.medium;
        }
        if( this.slideshow.quiz ) {
            useImage = image.sizes.quiz;
        }
        if( this.adsTab && image.sizes.ad) {
            useImage = image.sizes.ad;
        }
        let width = useImage.width;
        let height = useImage.height;
        if( useImage.crop ) {
            width = useImage.crop.width;
            height = useImage.crop.height;
        }
        return width + 'x' + height;
    }
    getSize(image) {
        return image.sizes.mobile ? 'mobile' : 'medium';
    }
    getSrc(image, index, mobile, prop = 'urlWithParams') {
        if( index == 0 ) {
            if( this.adsTab && image.sizes.ad) {
                return image.sizes.ad[prop];
            }
            if( mobile ) {
                return image.sizes.mobile ? image.sizes.mobile[prop] : image.sizes.medium[prop]
            }
            if( this.slideshow.quiz ) {
                return image.sizes.quiz[prop];
            }
            return image.sizes.desktop ? image.sizes.desktop[prop] : image.sizes.full[prop];
        }
        return image.sizes.thumbnail[prop];
    }
    showPlaceholder() {
        if( this.images.length > 0 && (this.canEdit || typeof this.images[0].sizes.mobile !== 'undefined') ) {
            return false;
        }
        return true;
    }
    showNotice(image, index) {
        if( this.adsTab && image.sizes.ad && this.canEdit) {
            let adSize = image.sizes.ad;
            if( adSize && adSize.crop ) {
                adSize = adSize.crop;
            }
            if( adSize && (adSize.width > image.sizes.full.width || adSize.height > image.sizes.full.height) ) {
                return true;
            }
        }
        let desktopSize = image.sizes.desktop;
        if( desktopSize && desktopSize.crop ) {
            desktopSize = desktopSize.crop;
        }
        if( !this.slideshow.quiz && this.canEdit && index == 0 && desktopSize && desktopSize.width > image.sizes.full.width ) {
            return true;
        }
        return false;
    }
    ngOnDestroy() {
        if( this.imageUploadSubscription ) {
            this.imageUploadSubscription.unsubscribe();
        }
        if( this.gettyDownloadSubscription ) {
            this.gettyDownloadSubscription.unsubscribe();
        }
    }
}
@Component({
    selector: 'mobile-only-dialog',
    template: `
        <h2 mat-dialog-title>Not Allowed</h2>
        <mat-dialog-content>
            <p>Images less than 600 width are not allowed as the desktop image. Please select a different image.</p>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button class="button" mat-dialog-close>Ok</button>
        </mat-dialog-actions>`,
})
export class MobileOnlyDialog {
    constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }
}